/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Outcome of a vendor-specific code search. Available means the supplier returned code-search offers, not a guarantee of renter eligibility.
 * @export
 * @interface VehicleCorporateCodeOutcome
 */
export interface VehicleCorporateCodeOutcome {
    /**
     * 
     * @type {string}
     * @memberof VehicleCorporateCodeOutcome
     */
    vendorCode: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleCorporateCodeOutcome
     */
    status: VehicleCorporateCodeOutcomeStatusEnum;
}


/**
 * @export
 */
export const VehicleCorporateCodeOutcomeStatusEnum = {
    Available: 'available',
    Unavailable: 'unavailable',
    Error: 'error',
    Rejected: 'rejected',
    Unsupported: 'unsupported'
} as const;
export type VehicleCorporateCodeOutcomeStatusEnum = typeof VehicleCorporateCodeOutcomeStatusEnum[keyof typeof VehicleCorporateCodeOutcomeStatusEnum];


/**
 * Check if a given object implements the VehicleCorporateCodeOutcome interface.
 */
export function instanceOfVehicleCorporateCodeOutcome(value: object): value is VehicleCorporateCodeOutcome {
    if (!('vendorCode' in value) || value['vendorCode'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function VehicleCorporateCodeOutcomeFromJSON(json: any): VehicleCorporateCodeOutcome {
    return VehicleCorporateCodeOutcomeFromJSONTyped(json, false);
}

export function VehicleCorporateCodeOutcomeFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleCorporateCodeOutcome {
    if (json == null) {
        return json;
    }
    return {
        
        'vendorCode': json['vendor_code'],
        'status': json['status'],
    };
}

export function VehicleCorporateCodeOutcomeToJSON(json: any): VehicleCorporateCodeOutcome {
    return VehicleCorporateCodeOutcomeToJSONTyped(json, false);
}

export function VehicleCorporateCodeOutcomeToJSONTyped(value?: VehicleCorporateCodeOutcome | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'vendor_code': value['vendorCode'],
        'status': value['status'],
    };
}

